module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-uploadImages","title":"图片上传","type":"qs-other","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}


//////////////////
// WEBPACK FOOTER
// ./components/pipeline-uploadImages/package.json
// module id = 298
// module chunks = 1